export default (hotkeysManager) => () => {
  hotkeysManager.restoreHotkeys();
};